import React from 'react'

export default function PageNotFound() {
  return (
    <div className='p-5 notfound text-center m-5 fw-bold'>Page Not Found</div>
  )
}
